import { Component, OnInit } from '@angular/core';
import { Sector } from '../models/Sector';
import { SectorService } from '../services/sector.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

@Component({
  selector: 'app-sector-carousel',
  templateUrl: './sector-carousel.component.html',
  styleUrls: ['./sector-carousel.component.css']
})
export class SectorCarouselComponent implements OnInit {

  sectores: Sector[]
  preload: Boolean = false

  customOptions: OwlOptions = {
    animateIn: true,
    margin: 10,
    loop: true,
    autoplay:true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 1500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }

  constructor(
    private sectorService: SectorService
  ) { }

  ngOnInit() {

    this.preload = true

    this.sectorService.getSectores().subscribe((res) => {
      this.sectores = res
      console.log('Sectores: ',res);
    })

    this.preload = false
    
  }

}
